const BARCODE_PATTERN = /^[0-9_]{13}$/;
const FILE_BASE_NAME_PATTERN = /^([0-9_]{13})_(\d+)$/;

export type ParsedProductFileName = {
    barcode: string;
    uniqueNumber: string;
};

export const isValidProductBarcode = (barcode: string): boolean => BARCODE_PATTERN.test(barcode);

export const parseProductFileName = (fileName: string): ParsedProductFileName | null => {
    const baseName = fileName.replace(/\.[^/.]+$/, '');
    const match = FILE_BASE_NAME_PATTERN.exec(baseName);
    if (!match) {
        return null;
    }

    const barcode = match[1];
    if (!isValidProductBarcode(barcode)) {
        return null;
    }

    return {
        barcode,
        uniqueNumber: match[2],
    };
};
